module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av356-c6e38365d8447ec7db7f158b6c7dbc34.jpg";